
<template>
	<div id="newQianniuExamex" style="max-width:100%;">
		<input ref="fileInputSix" type="file" accept=".csv" style="display:none" @change="onSixFileChange" />
		<div class="el-tabs el-tabs--left">
			<div class="el-tabs__header is-left">
				<div class="el-tabs__nav-wrap is-left">
					<div class="el-tabs__nav-scroll">
						<div class="el-tabs__nav is-left">
							<div class="el-tabs__active-bar is-left" style="height: 50px; transform: translateY(0px);"></div>
							<div id="tab-first" class="el-tabs__item js-tab is-left is-active">
								<div class="tab-slot">
									<p class="title">1、登录拼多多商家版</p>
								</div>
							</div>
							<div id="tab-second" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">2、基础设置</p>
								</div>
							</div>
							<div id="tab-third" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">3、订单管理</p>
								</div>
							</div>
							<div id="tab-four" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">4、会话窗口常用功能</p>
								</div>
							</div>
							<div id="tab-five" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">5、插件常用功能</p>
								</div>
							</div>
							<div id="tab-six" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">6、添加快捷回复</p>
								</div>
							</div>
							<div id="tab-seven" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">7、退出账号</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="el-tabs__content">
				<div id="tab-first-content" class="el-tab-pane">
					<div id="stoptip-first" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-first" class="content">
						<div class="con-left" style="padding: 0;">
							<StepPlayer
								ref="playerFirst"
								:steps="scenarioConfig.first.steps"
								:initial-step-id="scenarioConfig.first.initialStepId"
								:initial-form="scenarioConfig.first.initialForm"
								:show-tip="false"
								@finish="onFinish('first')"
								@guard-failed="onGuardFailed('first', $event)"
								@step-change="(stepId, step, resolvedTip) => onStepChange('first', stepId, step, resolvedTip)"
							/>
						</div>
						<div class="con-right">
							<h3><span class="line"></span>提示</h3>
							<div class="tip-body">
								<template v-if="tabCurrent === 'first' && currentStepId.first === 'login2'">
									<p>1.复制粘贴账号和密码</p>
									<p>2.自动登录不要勾选</p>
									<el-button
										v-if="!showLoginPassword"
										type="primary"
										size="mini"
										@click="showLoginPassword = true"
									>
										获取账号密码
									</el-button>
									<template v-if="showLoginPassword">
										<p><span style="color: red;font-weight:normal;">账号：淘金云客服:小淘</span></p>
										<p><span style="color: red;font-weight:normal;">密码：Tj1234</span></p>
									</template>
								</template>
								<template v-else>
									<div v-html="rightTip.first"></div>
								</template>
							</div>
						</div>
					</div>
					<div id="studytip-first" class="stoptip" style="height: 696px;">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>考核通关，进入下一关吧</p>
							<p>
								<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重考</a>
								<a class="startstudy" @click="studyNext('#tab-second', 2, 'second')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>

				<div id="tab-second-content" class="el-tab-pane" :class="{ mynone: tabCurrent !== 'second' }">
					<div id="stoptip-second" class="stoptip" v-show="false">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始考核</a>
							</p>
						</div>
					</div>
					<div id="content-second" class="content">
						<div class="con-left" style="padding: 0;">
							<StepPlayer
								ref="playerSecond"
								:steps="scenarioConfig.second.steps"
								:initial-step-id="scenarioConfig.second.initialStepId"
								:initial-form="scenarioConfig.second.initialForm"
								:show-tip="false"
								@finish="onFinish('second')"
								@guard-failed="onGuardFailed('second', $event)"
								@step-change="(stepId, step, resolvedTip) => onStepChange('second', stepId, step, resolvedTip)"
							/>
						</div>
						<div class="con-right">
							<h3><span class="line"></span>提示</h3>
							<div class="tip-body" v-html="rightTip.second"></div>
						</div>
					</div>
					<div id="studytip-second" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>考核通关，进入下一关吧</p>
							<p>
								<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重考</a>
								<a class="startstudy" @click="studyNext('#tab-third', 3, 'third')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>

				<div id="tab-third-content" class="el-tab-pane" :class="{ mynone: tabCurrent !== 'third' }">
					<div id="stoptip-third" class="stoptip" v-show="false">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始考核</a>
							</p>
						</div>
					</div>
					<div id="content-third" class="content">
						<div class="con-left" style="padding: 0;">
							<StepPlayer
								ref="playerThird"
								:steps="scenarioConfig.third.steps"
								:initial-step-id="scenarioConfig.third.initialStepId"
								:initial-form="scenarioConfig.third.initialForm"
								:show-tip="false"
								@finish="onFinish('third')"
								@guard-failed="onGuardFailed('third', $event)"
								@step-change="(stepId, step, resolvedTip) => onStepChange('third', stepId, step, resolvedTip)"
							/>
						</div>
						<div class="con-right">
							<h3><span class="line"></span>提示</h3>
							<div class="tip-body" v-html="rightTip.third"></div>
						</div>
					</div>
					<div id="studytip-third" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>考核通关，进入下一关吧</p>
							<p>
								<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重考</a>
								<a class="startstudy" @click="studyNext('#tab-four', 4, 'four')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>

				<div id="tab-four-content" class="el-tab-pane" :class="{ mynone: tabCurrent !== 'four' }">
					<div id="stoptip-four" class="stoptip" v-show="false">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始考核</a>
							</p>
						</div>
					</div>
					<div id="content-four" class="content">
						<div class="con-left" style="padding: 0;">
							<StepPlayer
								ref="playerFour"
								:steps="scenarioConfig.four.steps"
								:initial-step-id="scenarioConfig.four.initialStepId"
								:initial-form="scenarioConfig.four.initialForm"
								:show-tip="false"
								@finish="onFinish('four')"
								@guard-failed="onGuardFailed('four', $event)"
								@step-change="(stepId, step, resolvedTip) => onStepChange('four', stepId, step, resolvedTip)"
							/>
						</div>
						<div class="con-right">
							<h3><span class="line"></span>提示</h3>
							<div class="tip-body" v-html="rightTip.four"></div>
						</div>
					</div>
					<div id="studytip-four" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>考核通关，进入下一关吧</p>
							<p>
								<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重考</a>
								<a class="startstudy" @click="studyNext('#tab-five', 5, 'five')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>

				<div id="tab-five-content" class="el-tab-pane" :class="{ mynone: tabCurrent !== 'five' }">
					<div id="stoptip-five" class="stoptip" v-show="false">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始考核</a>
							</p>
						</div>
					</div>
					<div id="content-five" class="content">
						<div class="con-left" style="padding: 0;">
							<StepPlayer
								ref="playerFive"
								:steps="scenarioConfig.five.steps"
								:initial-step-id="scenarioConfig.five.initialStepId"
								:initial-form="scenarioConfig.five.initialForm"
								:show-tip="false"
								@finish="onFinish('five')"
								@guard-failed="onGuardFailed('five', $event)"
								@step-change="(stepId, step, resolvedTip) => onStepChange('five', stepId, step, resolvedTip)"
							/>
						</div>
						<div class="con-right">
							<h3><span class="line"></span>提示</h3>
							<div class="tip-body" v-html="rightTip.five"></div>
						</div>
					</div>
					<div id="studytip-five" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>考核通关，进入下一关吧</p>
							<p>
								<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重考</a>
								<a class="startstudy" @click="studyNext('#tab-six', 6, 'six')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>

				<div id="tab-six-content" class="el-tab-pane" :class="{ mynone: tabCurrent !== 'six' }">
					<div id="stoptip-six" class="stoptip" v-show="false">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始考核</a>
							</p>
						</div>
					</div>
					<div id="content-six" class="content">
						<div class="con-left" style="padding: 0;">
							<StepPlayer
								ref="playerSix"
								:steps="scenarioConfig.six.steps"
								:initial-step-id="scenarioConfig.six.initialStepId"
								:initial-form="scenarioConfig.six.initialForm"
								:show-tip="false"
								@finish="onFinish('six')"
								@guard-failed="onGuardFailed('six', $event)"
								@step-change="(stepId, step, resolvedTip) => onStepChange('six', stepId, step, resolvedTip)"
								@request-file="onRequestFile"
								@download-file="downloadKjdyFile"
							/>
						</div>
						<div class="con-right">
							<h3><span class="line"></span>提示</h3>
							<div class="tip-body" v-html="rightTip.six"></div>
							<p v-if="rightTip.six && rightTip.six.indexOf('下载') !== -1"><a @click="downloadKjdyFile">点击下载“快捷短语.csv”</a></p>
						</div>
					</div>
					<div id="studytip-six" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>考核通关，进入下一关吧</p>
							<p>
								<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重考</a>
								<a class="startstudy" @click="studyNext('#tab-seven', 7, 'seven')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>

				<div id="tab-seven-content" class="el-tab-pane" :class="{ mynone: tabCurrent !== 'seven' }">
					<div id="stoptip-seven" class="stoptip" v-show="false">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始考核</a>
							</p>
						</div>
					</div>
					<div id="content-seven" class="content">
						<div class="con-left" style="padding: 0;">
							<StepPlayer
								ref="playerSeven"
								:steps="scenarioConfig.seven.steps"
								:initial-step-id="scenarioConfig.seven.initialStepId"
								:initial-form="scenarioConfig.seven.initialForm"
								:show-tip="false"
								@finish="onFinish('seven')"
								@guard-failed="onGuardFailed('seven', $event)"
								@step-change="(stepId, step, resolvedTip) => onStepChange('seven', stepId, step, resolvedTip)"
							/>
						</div>
						<div class="con-right">
							<h3><span class="line"></span>提示</h3>
							<div class="tip-body" v-html="rightTip.seven"></div>
						</div>
					</div>
					<div id="studytip-seven" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>考核通关</p>
							<p>
								<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重考</a>
								<a class="startstudy" @click="goBack">返回</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getScenarioConfig } from './pddStudyScenarios'
import StepPlayer from '@/components/simulate/StepPlayer.vue'

const TAB_KEYS = ['first', 'second', 'third', 'four', 'five', 'six', 'seven']

export default {
	components: { StepPlayer },
	data() {
		const rightTip = {}
		TAB_KEYS.forEach(k => { rightTip[k] = '' })
		return {
			tabIndex: 1,
			tabCurrent: 'first',
			scenarioConfig: getScenarioConfig(),
			rightTip,
			currentStepId: TAB_KEYS.reduce((m, k) => { m[k] = ''; return m }, {}),
			showLoginPassword: false
		}
	},
	mounted() {
		this.initAll()
	},
	methods: {
		goBack() {
			if (window.parent && typeof window.parent['goBack'] === 'function') {
				window.parent['goBack']()
				return
			}
			this.$router && this.$router.back && this.$router.back()
		},
		initAll() {
			TAB_KEYS.forEach(k => {
				this.rightTip[k] = ''
			})
			const playerRefs = ['playerFirst', 'playerSecond', 'playerThird', 'playerFour', 'playerFive', 'playerSix', 'playerSeven']
			playerRefs.forEach((ref, i) => {
				const player = this.$refs[ref]
				const tabKey = TAB_KEYS[i]
				if (player && this.scenarioConfig[tabKey]) {
					player.reset(this.scenarioConfig[tabKey].initialStepId)
				}
			})
			$('.content').each(function () { $(this).hide() })
			$('.stoptip').each(function () { $(this).hide() })
			$('.el-tabs__content').find('.el-tab-pane').each(function () { $(this).hide() })
			$('#tab-' + this.tabCurrent + '-content').show()
			if (this.tabCurrent === 'first') {
				$('#stoptip-' + this.tabCurrent).show()
			} else {
				$('#content-' + this.tabCurrent).css('display', 'flex')
			}
		},
		startStudy() {
			$('#stoptip-' + this.tabCurrent).hide()
			$('#content-' + this.tabCurrent).css('display', 'flex')
			const ref = 'player' + this.tabCurrent.charAt(0).toUpperCase() + this.tabCurrent.slice(1)
			const player = this.$refs[ref]
			const cfg = this.scenarioConfig[this.tabCurrent]
			if (player && cfg) {
				player.reset(cfg.initialStepId)
			}
			this.addRecord('START', this.tabIndex)
		},
		onFinish(tabKey) {
			this.addRecord('END', this.tabIndex)
			setTimeout(() => {
				$('#studytip-' + tabKey).show()
			}, 2000)
		},
		onStepChange(tabKey, stepId, step, resolvedTip) {
			this.$set(this.currentStepId, tabKey, stepId)
			if (tabKey === 'first' && stepId !== 'login2') {
				this.showLoginPassword = false
			}
			this.$set(this.rightTip, tabKey, resolvedTip || '')
		},
		onGuardFailed(tabKey, res) {
			this.$alert(res && res.msg ? res.msg : '校验未通过')
		},
		onRequestFile() {
			this.$refs.fileInputSix && this.$refs.fileInputSix.click()
		},
		onSixFileChange(evt) {
			const file = evt.target.files && evt.target.files[0]
			if (!file || (file.name && file.name.indexOf('快捷短语') < 0)) {
				this.$alert('请选择你下载的“快捷短语.csv”模板文件')
				return
			}
			const player = this.$refs.playerSix
			if (player) player.go('six_5')
			setTimeout(() => {
				if (this.$refs.fileInputSix) this.$refs.fileInputSix.value = ''
			}, 300)
		},
		downloadKjdyFile() {
			const path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'
			fetch(path).then(r => r.blob()).then(blob => {
				const a = document.createElement('a')
				a.href = window.URL.createObjectURL(blob)
				a.download = '快捷短语.csv'
				a.click()
				a.remove()
			})
		},
		restartStudy() {
			const cfg = this.scenarioConfig[this.tabCurrent]
			if (!cfg) return
			const ref = 'player' + this.tabCurrent.charAt(0).toUpperCase() + this.tabCurrent.slice(1)
			const player = this.$refs[ref]
			if (player) player.reset(cfg.initialStepId)
			$('#studytip-' + this.tabCurrent).hide()
			this.addRecord('START', this.tabIndex)
		},
		studyNext(next, index, tabCurrent) {
			if (index !== this.tabIndex + 1) return
			$('.el-tabs__header').find('.js-tab').each(function () {
				$(this).removeClass('is-active')
			})
			$(next).addClass('is-active')
			$('.el-tabs__content').find('.el-tab-pane').each(function () {
				$(this).hide()
			})
			$(next + '-content').show()
			this.tabIndex = index
			this.tabCurrent = tabCurrent
			this.initAll()
			this.addRecord('START', this.tabIndex)
		},
		addRecord(type, stepSeq) {
			const data = {
				exerciseType: 'PDD_EXAM',
				stepSeq: stepSeq,
				exerciseAction: type
			}
			this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res => {
				const result = res.data
				if (result && result.success) {
					return
				}
				this.$message({
					message: (result && result.msg) || '操作失败',
					type: 'error',
					center: true,
					duration: 1000
				})
			}, () => {
				this.$message({
					message: '网络繁忙，请稍后重试！',
					type: 'error',
					center: true,
					duration: 1000
				})
			})
		}
	}
}
</script>

<style lang="less" scoped>
/deep/ .el-tabs__content {
	height: 100% !important;
}

.con-left {
	background: none !important;
	flex: 1 1 auto;
	min-width: 1;
}

.con-right {
	width: 170px;
	flex: 0 0 170px;
}

.stoptip {
	width: 100% !important;
	height: 100% !important;
}
</style>




// WEBPACK FOOTER //
// ./src/page/simulate/pddExam.vue